module.exports = __webpack_public_path__ + "static/media/BabyCourse_Desktop_Main_4.61a849d7.jpg";